<script module>
  let toasts = $state([]);
  let nextId = 0;

  export function addToast(message, type = "info", duration = 4000) {
    const id = nextId++;
    toasts.push({ id, message, type });
    setTimeout(() => {
      toasts = toasts.filter((t) => t.id !== id);
    }, duration);
  }

  export const show = addToast;
</script>

<script>
  const typeColors = {
    success: "bg-emerald-500/15 border-emerald-500/30 text-emerald-200",
    error: "bg-red-500/10 border-red-500/20 text-red-200",
    info: "ui-card text-zinc-200",
    warning: "bg-amber-500/15 border-amber-500/30 text-amber-200",
  };
</script>

<div class="fixed bottom-4 right-4 z-50 space-y-2">
  {#each toasts as toast (toast.id)}
    <div class="px-4 py-3 rounded border border-white/10 text-sm shadow-lg backdrop-blur-sm {typeColors[toast.type] || typeColors.info}">
      {toast.message}
    </div>
  {/each}
</div>
